import {
  asValueFrom,
  combineLatestTyped,
  filterNotUndefined,
  useDataStream,
  useStateAsStream,
  useStreamEffect,
  useStreamValue,
  useValueAsStream,
  useVoidEventAsStream,
  valueIs
} from 'annotation-tools/utils';
import { map } from 'rxjs/operators';
import { startTraining } from '../../../api/fetch-functions/model';
import { modelDetailEnabledButtons } from '../../../constants/model-detail-enabled-buttons';
import { viewTexts } from '../../../constants/view-texts';
import { envMode } from '../../../env-values';
import { token$ } from '../../../global-state/auth-state';
import { fetchModelListOf } from '../../../global-state/database/model-list';
import { companyId$ } from '../../../global-state/router-id';
import { IModelType } from '../../../types/record/model';
import { LoadingButtonState } from '../../shared/mui/loading-button-state';

const vt = viewTexts.pages.modelDetail;

export const useStartTrainingButtonHandler = (model: IModelType) => {
  const model$ = useValueAsStream(model);

  const [startTrainingClick$, onStartTrainingClick] = useVoidEventAsStream();

  const [
    // dummy comment
    fetchStatus$,
    setFetchStatus
  ] = useStateAsStream<LoadingButtonState['status']>('init');

  useStreamEffect(
    startTrainingClick$.pipe(
      asValueFrom(
        combineLatestTyped(
          token$.pipe(filterNotUndefined()),
          companyId$,
          model$
        )
      )
    ),
    ([token, companyId, mdl]) => {
      setFetchStatus('pending');
      startTraining(token)(mdl.id)({}).then(res => {
        fetchModelListOf(companyId);
        setFetchStatus(res.type);
        if (envMode !== 'production') {
          console.log(res); // TODO: handle response
        }
      });
    }
  );

  // This state is used to prevent the StartTrainingButton from being clicked twice.
  // Once the StartTrainingButton is clicked, disable the button until the model status change is complete.
  const startTrainingButtonIsDisabled$ = useDataStream<boolean>(
    true,
    combineLatestTyped(
      model$.pipe(
        map(m => !modelDetailEnabledButtons(m.status).executeTraining)
      ),
      fetchStatus$.pipe(valueIs('pending'))
    ).pipe(map(conditions => conditions.some(b => b)))
  );

  const startTrainingButtonIsDisabled = useStreamValue(
    startTrainingButtonIsDisabled$,
    true
  );

  const startTrainingButtonLabel =
    model.status === 'available' || model.status === 'failed'
      ? vt.section3.common.retrainButton
      : vt.section3.common.trainButton;

  const startTrainingButtonStatus = useStreamValue(fetchStatus$, 'init');

  return {
    startTrainingButtonLabel,
    startTrainingButtonIsDisabled,
    startTrainingButtonStatus,
    onStartTrainingClick
  };
};
